export default __webpack_public_path__ + "static/media/amex.f75c3f95.svg";